var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 26,
    fill: "#564AB3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6673 33.4444C18.192 33.4444 17.7955 33.2856 17.4777 32.9678C17.1599 32.65 17.0007 32.2531 17 31.7771V20.6673C17 20.192 17.1592 19.7955 17.4777 19.4777C17.7962 19.1599 18.1924 19.0007 18.6663 19H33.9052C34.3798 19 34.776 19.1592 35.0937 19.4777C35.4115 19.7962 35.5707 20.1927 35.5714 20.6673V31.7782C35.5714 32.2528 35.4122 32.6493 35.0937 32.9678C34.7753 33.2862 34.3791 33.4451 33.9052 33.4444H18.6673ZM26.2857 26.181C26.3717 26.181 26.4522 26.1679 26.5271 26.1417C26.6014 26.1156 26.675 26.0836 26.7479 26.0458L34.2064 21.1625C34.3041 21.1034 34.3677 21.0226 34.3973 20.9201C34.4269 20.8176 34.4214 20.7154 34.3808 20.6137C34.3547 20.4809 34.268 20.3846 34.1208 20.3248C33.9743 20.2656 33.8322 20.2776 33.6947 20.3609L26.2857 25.1905L18.8778 20.3619C18.7402 20.278 18.6013 20.2601 18.461 20.3083C18.3206 20.3564 18.2305 20.4513 18.1906 20.593C18.1507 20.6989 18.1456 20.8066 18.1752 20.916C18.2047 21.0253 18.268 21.1079 18.365 21.1636L25.8235 26.0458C25.8964 26.0836 25.97 26.1156 26.0443 26.1417C26.1193 26.1672 26.1997 26.1799 26.2857 26.1799",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mailIcon.01de6f31ca276bc81b4d69fd3a125b8d.svg";
export { ForwardRef as ReactComponent };